<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.statistics_manage')}}<span class="page-header-breadcrumb">></span>{{ $t('words.statistics_channel') }}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.statistics.channel_download_tip') }"><i class="icon icon-info-circle-line"></i></span></h3>
                    <div class="page-header-action-group"><a class="btn" :href="getExportUrl"><i class="icon icon-download"></i>{{ $t('words.statistics_download') }}</a></div>
                </div>
                <div class="page-sub-header clearfix">
                    <div class="form-inline float-left">
                        <div class="control-group" v-show="useWebRtc">
                            <label for="select_type" class="sr-only">{{ $t('words.channel_kind') }}</label>
                            <select id="select_type" :placeholder="$t('words.channel_kind')">
<!--                                <option value="">{{$t('words.channel_kind')}}</option>-->
<!--                                <option value="all">{{$t('words.all')}}</option>-->
                                <option value="except_webrtc">{{ $t('words.general') }}</option>
                                <option value="webrtc">{{ $t('words.webrtc') }}</option>
                            </select>
                        </div>
                        <div class="control-group">
                            <label for="select_channel" class="sr-only">{{ $t('words.all_channels') }}</label>
                            <select id="select_channel" :placeholder="$t('words.all_channels')">
                                <!--<option value="">All Channels</option>-->
                                <!--<option :value="channel.id" v-for="channel in selec
                                t.channels" :key="channel.id">{{ channel.title }}</option>-->
                            </select>
                        </div>
                        <div class="control-group">
                            <label for="select_live" class="sr-only">{{ $t('words.all_broadcasts') }}</label>
                            <select id="select_live" :placeholder="$t('words.all_broadcasts')">
                                <!--<option value="">All Lives</option>-->
                                <!--<option :value="broadcast.id" v-for="broadcast in select.broadcasts" :key="broadcast.id">{{ broadcast.title }}</option>-->
                            </select>
                        </div>
                        <div class="form-checkbox ml-2">
                            <input type="checkbox" v-model="includeTrashedChannel" id="includeTrashedChannel">
                            <label for="includeTrashedChannel">{{ $t('words.include_removed_channels')}}</label>
                        </div>
                    </div>
                    <div class="module-action-group float-right">
                        <div class="btn-group btn-group__date">
                            <button :class="{'btn': true, 'active': (period==='1d')}" @click="changePeriod('1d')">{{ $t('words.period_today') }}</button>
                            <button :class="{'btn': true, 'active': (period==='3d')}" @click="changePeriod('3d')">{{ $t('words.period_3d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='7d')}" @click="changePeriod('7d')">{{ $t('words.period_7d') }}</button>
                            <button :class="{'btn': true, 'active': (period==='30d')}" @click="changePeriod('30d')">{{ $t('words.period_30d') }}</button>
                        </div>
                        <div class="input-group input-group-date input-daterange" id="date-range">
                            <div class="input-group">
                                <vue-date-picker
                                    v-model="rangeDay"
                                    value-type="format"
                                    format="YYYY-MM-DD"
                                    range
                                    placeholder="Select date range"
                                    :disabled-date="notRangedDate"
                                >
                                </vue-date-picker>
                            </div>
                            <div class="input-group-append">
                                <button type="button" :class="{'btn': true, 'btn-icon': true, 'active': (period === 'custom')}" @click.prevent="doSearch"><i class="icon icon-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="module" v-if="loadSummary">
                <div class="module-header" v-if="selectedBroadcast">
                    <h4 class="module-title float-left" v-if="'live_creator' in broadcast">Creator: {{ 'nickname' in broadcast.live_creator ? broadcast.live_creator.nickname : '' }}({{ 'code' in broadcast.live_creator ? broadcast.live_creator.code: '' }})</h4>
                    <div class="text-help float-right">{{ renderDatetime(broadcast.started_at) }} ~ {{ renderDatetime(broadcast.paused_at) }}</div>
                </div>
                <div class="module-body">
                    <ul class="dashboard">
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.max_acc_user') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.sum_user }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.total_acc_user') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.total_acc_user }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.max_cur_user') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.max_cur_user }}</p>
                        </li>
                        <li class="dashboard-item">
                            <h5 class="dashboard-title">{{ $t('words.total_visit_count') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.total_count }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time">
                            <h5 class="dashboard-title">{{ $t('words.total_broadcast_interval') }}</h5>
                            <p class="dashboard-desc">
                                <span v-if="selectedBroadcast">{{ broadcast.interval }}</span>
                                <span v-else>{{ summaryData.total_broadcast_interval }}</span>
                            </p>
                        </li>
                        <li class="dashboard-item dashboard-item__time">
                            <h5 class="dashboard-title">{{ $t('words.total_watch_time') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.total_watch_time }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time" v-if="selectedChannel !=='' && selectedBroadcast === ''">
                            <h5 class="dashboard-title">{{ $t('words.average_broadcast_interval') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.average_broadcast_interval }}</p>
                        </li>
                        <li class="dashboard-item dashboard-item__time">
                            <h5 class="dashboard-title">{{ $t('words.average_watch_time') }}</h5>
                            <p class="dashboard-desc">{{ summaryData.average_watch_time }}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.watch_user') }}/{{ $t('words.visit_count') }}</h5>
                    <div class="module-header-action">
                        <select id="request_interval" style="width:130px" v-model="requestInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ withFullUnitStringIfEnglish(value) }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': requestData.loading}">
                    <request-chart ref="requestChart" :chartData="requestData" :interval="requestInterval" :created="requestData.created"></request-chart>
                </div>
            </div>

            <div class="module">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.traffic') }}/{{ $t('words.transfer') }}</h5>
                    <div class="module-header-action">
                        <select id="transfer_interval" style="width:130px" v-model="transferInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ withFullUnitStringIfEnglish(value) }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': transferData.loading}">
                    <transfer-chart ref="transferChart" :chartData="transferData" :interval="transferInterval" :created="transferData.created"></transfer-chart>
                </div>
            </div>

            <div class="module" v-show="(selectedType !== 'webrtc')">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.response_code') }}</h5>
                    <div class="module-header-action">
                        <select id="response_interval" style="width:130px" v-model="responseInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ withFullUnitStringIfEnglish(value) }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': responseData.loading}">
                    <response-chart ref="responseChart" :chartData="responseData" :interval="responseInterval" :created="responseData.created"></response-chart>
                </div>
            </div>
            <div class="module" v-show="(selectedType !== 'webrtc')">
                <div class="module-header">
                    <h5 class="module-title">{{ $t('words.profile') }}</h5>
                    <div class="module-header-action">
                        <select id="profile_interval" style="width:130px" v-model="profileInterval">
                            <option v-for="value in intervals" :value="value" :key="value">{{ withFullUnitStringIfEnglish(value) }}</option>
                        </select>
                    </div>
                </div>
                <div :class="{'module-body': true, 'chart_loading': profileData.loading}">
                    <profile-chart ref="profileChart" :chartData="profileData" :interval="profileInterval" :created="profileData.created"></profile-chart>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';
import DateTimeMixin from '../mixin/DateTimeMixin';
import RequestChart from './chart/RequestChart';
import TransferChart from './chart/TransferChart';
import ResponseChart from './chart/ResponseChart';
import ProfileChart from './chart/ProfileChart';
import 'selectize';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    mixins: [
        GlobalConfigMixin,
        DateTimeMixin,
    ],
    components: {
        RequestChart,
        TransferChart,
        ResponseChart,
        ProfileChart,
        VueDatePicker,
    },
    data() {
        return {
            intervals: ['5m', '10m', '1h', '1d'],
            typeSelectize: null,
            selectedType: 'except_webrtc',
            selectedChannel: '',
            selectize_channels: null,
            selectize_broadcasts: null,
            selectedBroadcast: '',
            includeTrashedChannel: false,
            channel: {},
            broadcast: {},
            startDayLimit: '',
            endDayLimit: '',
            rangeDay: [],
            startDay: '',
            endDay: '',
            startDate: '',
            endDate: '',
            period: '',
            requestSelectize: null,
            requestInterval: '5m',
            requestData: {
                loading: false,
                labels: null,
                results: {
                    count: {},
                    accUser: {},
                    curUser: {},
                },
                created: null,
            },
            transferSelectize: null,
            transferInterval: '5m',
            transferData: {
                loading: false,
                labels: null,
                results: {
                    traffic: {},
                    transfer: {},
                },
                created: null,
            },
            responseSelectize: null,
            responseInterval: '5m',
            responseData: {
                loading: false,
                labels: null,
                results: {

                },
                created: null,
            },
            profileSelectize: null,
            profileInterval: '5m',
            profileData: {
                loading: false,
                labels: null,
                legends: null,
                results: {

                },
                created: null,
            },
            summaryData: {
                total_count: 0,
                total_broadcast_interval: '',
                total_watch_time: '0',
                total_acc_user: 0,
                max_cur_user: 0,
                max_acc_user: 0,
                sum_user: 0,
                average_watch_time: '0',
                average_broadcast_interval: '',
            },
            loadSummary: false,
            // end random chart
        };
    },
    beforeDestroy() {
        this.data = {};
    },
    mounted() {
        const self = this;

        const selectizeTypeObj = $('#select_type').selectize({
            maxItems: 1,
            create: true,
            preload: true,
            // sortField: 'text',
            onChange(value) {
                if (value === 'all' || value === '') {
                    self.selectedType = '';
                } else {
                    self.selectedType = value;
                }
                self.selectedChannel = '';
                self.selectedBroadcast = '';
                self.selectize_channels.clear();
                self.selectize_broadcasts.clear();
                self.selectize_channels.onSearchChange('');
            },
        });
        this.typeSelectize = selectizeTypeObj[0].selectize;

        const selectizeRequestObj = $('#request_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.requestInterval = value;
                self.initRequestChartData();
                self.getRequestChartData();
            },
        });
        this.requestSelectize = selectizeRequestObj[0].selectize;

        const selectizeTransferObj = $('#transfer_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.transferInterval = value;
                self.initTransferChartData();
                self.getTransferChartData();
            },
        });
        this.transferSelectize = selectizeTransferObj[0].selectize;

        const selectizeResponseObj = $('#response_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.responseInterval = value;
                self.initResponseChartData();
                self.getResponseChartData();
            },
        });
        this.responseSelectize = selectizeResponseObj[0].selectize;

        const selectizeProfileObj = $('#profile_interval').selectize({
            maxItems: 1,
            create: true,
            onChange(value) {
                self.profileInterval = value;
                self.initProfileChartData();
                self.getProfileChartData();
            },
        });
        this.profileSelectize = selectizeProfileObj[0].selectize;
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            // this.loadChannel();
            this.initSelectableDate('1y');
            this.changePeriod('1d');
            this.loadSelectChannel();
            // this.loadBroadcast();
        },
        adjustInterval() {
            let adjustInterval = '5m';
            if (this.$moment(this.endDay).subtract(29, 'day') >= this.$moment(this.startDay)) {
                adjustInterval = '1d';
            } else if (this.$moment(this.endDay).subtract(6, 'day') >= this.$moment(this.startDay)) {
                adjustInterval = '1h';
            } else if (this.$moment(this.endDay).subtract(2, 'day') >= this.$moment(this.startDay)) {
                adjustInterval = '10m';
            }
            this.requestInterval = adjustInterval;
            this.requestSelectize.setValue(this.requestInterval, true);
            this.transferInterval = adjustInterval;
            this.transferSelectize.setValue(this.transferInterval, true);
            this.responseInterval = adjustInterval;
            this.responseSelectize.setValue(this.responseInterval, true);
            this.profileInterval = adjustInterval;
            this.profileSelectize.setValue(this.profileInterval, true);
        },
        doSearch() {
            this.setUtcStartEndDateTime();
            this.period = 'custom';
            this.adjustInterval();
            this.loadChart();
        },
        loadChart() {
            this.loadSummary = false;

            this.initStorageUsagesSummary();
            this.initRequestChartData();
            this.initTransferChartData();
            if (this.selectedType !== 'webrtc') {
                this.initResponseChartData();
                this.initProfileChartData();
            }

            this.getRequestChartData();
            this.getTransferChartData();
            if (this.selectedType !== 'webrtc') {
                this.getResponseChartData();
                this.getProfileChartData();
            }

            this.loadStorageUsagesSummary();
        },
        loadChannel() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.channelApi).then((response) => {
                this.channel = response.data.data;
            });
        },
        loadBroadcast() {
            if (typeof this.selectedServiceAccount === 'undefined') {
                return;
            }
            axios.get(this.broadcastApi).then((response) => {
                this.broadcast = response.data.data;
                // this.broadcast.repeat = null;
                // if (this.broadcast.is_onair) {
                //     this.calBroadcastDuration(this.broadcast);
                // }
            });
        },
        // getDuration(started) {
        //     const startedUtc = this.$moment.utc(started);
        //     const nowDate = this.$moment().utc();
        //     let diff;
        //     diff = nowDate.format('X') - startedUtc.format('X');
        //     const days = Math.floor(diff / (24 * 60 * 60));
        //     if (days > 0) {
        //         diff %= (24 * 60 * 60);
        //     }
        //     const hours = Math.floor(diff / (60 * 60));
        //     const hoursStr = (hours < 10) ? `0${hours}` : hours;
        //     if (hours > 0) {
        //         diff %= (60 * 60);
        //     }
        //     const minutes = Math.floor(diff / 60);
        //     const minutesStr = (minutes < 10) ? `0${minutes}` : minutes;
        //     if (minutes > 0) {
        //         diff %= (60);
        //     }
        //     const seconds = diff;
        //     const secondsStr = (seconds < 10) ? `0${seconds}` : seconds;
        //     if (days > 0) {
        //         return `${days}d ${hoursStr}:${minutesStr}:${secondsStr}`;
        //     }
        //     return `${hoursStr}:${minutesStr}:${secondsStr}`;
        // },
        // calBroadcastDuration(broadcast) {
        //     const broadcastIns = broadcast;
        //     broadcastIns.repeat = setInterval(() => {
        //         broadcastIns.interval = this.getDuration(broadcast.started_at);
        //
        //         if (!broadcastIns.is_onair) {
        //             clearInterval(broadcastIns.repeat);
        //         }
        //     }, 1000);
        // },
        loadSelectChannel() {
            const self = this;

            const selectizeObj = $('#select_channel').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                create: false,
                maxItems: 1,
                onChange(value) {
                    self.loadSummary = false;
                    self.selectedChannel = value;
                    self.selectedBroadcast = '';
                    // self.loadChannel();
                    self.loadChart();
                    // self.loadRecordFiles(self.recordingFilesApiUri);

                    // 방송 검색되도록 수정.
                    self.selectize_broadcasts.clear();
                    self.selectize_broadcasts.onSearchChange('');
                    // self.selectize_broadcasts.clear();
                    // self.selectize_broadcasts.clearOptions();
                    // self.selectize_broadcasts.disable();
                    // self.selectize_broadcasts.load((query, callback) => {
                    //     if (!value.length) {
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //         return;
                    //     }
                    //     const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    //     axios.get(broadcastUri).then((response) => {
                    //         self.selectize_broadcasts.enable();
                    //         response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                    //         callback(response.data.data);
                    //     }).catch((error) => {
                    //         // self.$toasted.error('Failed to load lives');
                    //         // console.log(error.response.data.errors);
                    //         callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    //     });
                    // });

                    // self.selectize_broadcasts.setValue('', true);
                },
                load(query, callback) {
                    this.clearOptions();

                    self.selectedChannel = '';
                    self.selectedBroadcast = '';

                    const uri = `/cms/${self.selectedServiceAccount.key}/select_channels?keyword=${query}&with_trashed=${self.includeTrashedChannel}&kind=${self.selectedType}`;

                    axios.get(uri).then((response) => {
                        response.data.data.unshift({ id: '', title: self.$t('words.all_channels') });
                        callback(response.data.data);
                    }).catch((error) => {
                        self.$toasted.error('Failed to load channels');
                        console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_channels') }]);
                    });
                },
            });

            this.selectize_channels = selectizeObj[0].selectize;
            this.loadSelectBroadcast();
        },
        loadSelectBroadcast() {
            const self = this;
            const selectizeObj = $('#select_live').selectize({
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                preload: true,
                maxItems: 1,
                create: false,
                onChange(value) {
                    self.selectedBroadcast = value;
                    // self.loadRecordFiles(self.recordingFilesApiUri);
                    // if (!value.length) return;

                    self.loadBroadcast();
                    self.loadChart();
                },
                load(query, callback) {
                    this.clearOptions();
                    if (self.selectedChannel.length === 0) {
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                        return;
                    }
                    const broadcastUri = `/cms/${self.selectedServiceAccount.key}/channels/${self.selectedChannel}/select_broadcasts?keyword=${query}`;
                    axios.get(broadcastUri).then((response) => {
                        // self.selectize_broadcasts.enable();
                        response.data.data.unshift({ id: '', title: self.$t('words.all_broadcasts') });
                        callback(response.data.data);
                    }).catch((error) => {
                        // self.$toasted.error('Failed to load lives');
                        // console.log(error.response.data.errors);
                        callback([{ id: '', title: self.$t('words.all_broadcasts') }]);
                    });
                },
            });

            this.selectize_broadcasts = selectizeObj[0].selectize;
            // this.selectize_broadcasts.clearOptions();
            // this.selectize_broadcasts.disable();
        },
        changePeriod(period) {
            this.extractRangeDayFromPeriod(period);
            this.setUtcStartEndDateTime();

            this.adjustInterval();
            this.loadChart();
        },
        initTransferChartData() {
            this.transferData.loading = true;
            this.transferData.labels = [];
            this.transferData.results.transfer = [];
            this.transferData.results.traffic = [];
            // this.transferData.created = moment().utc().format('X');
            this.$refs.transferChart.initialize();
        },
        async getTransferChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/transfer${this.queryStringApi(this.transferInterval)}`;

            await axios.get(apiLoc).then((response) => {
                this.transferData.labels = response.data.labels;
                this.transferData.results.transfer = response.data.transferData;
                this.transferData.results.traffic = response.data.trafficData;

                // this.transferData.created = moment().utc().format('X') + 5;
                this.$refs.transferChart.initialize();
                this.transferData.loading = false;
            }).catch((error) => {
                this.transferData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        initResponseChartData() {
            this.responseData.loading = true;
            this.responseData.labels = [];
            this.responseData.results.results_1xx = [];
            this.responseData.results.results_2xx = [];
            this.responseData.results.results_3xx = [];
            this.responseData.results.results_4xx = [];
            this.responseData.results.results_5xx = [];

            this.$refs.responseChart.initialize();
            // this.responseData.created = moment().utc().format('X');
        },
        async getResponseChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/response${this.queryStringApi(this.responseInterval)}`;

            await axios.get(apiLoc).then((response) => {
                this.responseData.labels = response.data.labels;
                this.responseData.results.results_1xx = response.data.results_1xx;
                this.responseData.results.results_2xx = response.data.results_2xx;
                this.responseData.results.results_3xx = response.data.results_3xx;
                this.responseData.results.results_4xx = response.data.results_4xx;
                this.responseData.results.results_5xx = response.data.results_5xx;

                this.$refs.responseChart.initialize();
                this.responseData.loading = false;
                // this.responseData.created = moment().utc().format('X') + 5;
            }).catch((error) => {
                this.responseData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        initRequestChartData() {
            this.requestData.loading = true;
            this.requestData.labels = [];
            this.requestData.results.count = [];
            this.requestData.results.accUser = [];
            this.requestData.results.curUser = [];
            // this.requestData.created = moment().utc().format('X');
            this.$refs.requestChart.initialize();

            this.summaryData.total_count = 0;
            this.summaryData.total_watch_time = '0';
            this.summaryData.total_acc_user = 0;
            this.summaryData.max_cur_user = 0;
            this.summaryData.max_acc_user = 0;
            this.summaryData.sum_user = 0;
            this.summaryData.average_watch_time = '0';
        },
        async getRequestChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/request${this.queryStringApi(this.requestInterval)}`;
            const self = this;
            await axios.get(apiLoc).then((response) => {
                self.requestData.labels = response.data.labels;
                self.requestData.results.count = response.data.countData;
                self.requestData.results.accUser = response.data.accUserData;
                self.requestData.results.curUser = response.data.curUserData;
                // self.requestData.created = moment().utc().format('X') + 5;
                this.$refs.requestChart.initialize();
                this.requestData.loading = false;

                self.summaryData.total_count = response.data.summaryData.total_count;
                self.summaryData.total_watch_time = response.data.summaryData.total_watch_time;
                self.summaryData.total_acc_user = response.data.summaryData.total_acc_user;
                self.summaryData.average_watch_time = response.data.summaryData.average_watch_time;
                self.summaryData.max_cur_user = response.data.summaryData.max_cur_user;
                self.summaryData.max_acc_user = response.data.summaryData.max_acc_user;
                self.summaryData.sum_user = response.data.summaryData.sum_user;
                this.loadSummary = true;
            }).catch((error) => {
                this.loadSummary = true;
                this.requestData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        initProfileChartData() {
            this.profileData.loading = true;
            this.profileData.labels = [];
            this.profileData.legends = [];
            this.profileData.results = [];

            this.$refs.profileChart.initialize();
            // this.responseData.created = moment().utc().format('X');
        },
        async getProfileChartData() {
            const apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/profile${this.queryStringApi(this.profileInterval)}`;

            await axios.get(apiLoc).then((response) => {
                this.profileData.labels = response.data.labels;
                this.profileData.legends = response.data.legends;
                this.profileData.results = response.data.results;

                this.$refs.profileChart.initialize();
                this.profileData.loading = false;
                // this.responseData.created = moment().utc().format('X') + 5;
            }).catch((error) => {
                this.profileData.loading = false;
                // console.log(error);
                // this.$toasted.error(this.$t('paragraphs.message.error.update_statistics'));
            });
        },
        queryStringApi(interval) {
            let query = '';
            if (this.selectedChannel !== '') {
                query += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    query += `/${this.selectedBroadcast}`;
                }
            }
            query += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${interval}&with_trashed=${this.includeTrashedChannel}&kind=${this.selectedType}`;

            return query;
        },
        initStorageUsagesSummary() {
            this.summaryData.total_broadcast_interval = '';
            this.summaryData.average_broadcast_interval = '';
        },
        loadStorageUsagesSummary() {
            axios.get(this.storageUsageSummaryApi).then((response) => {
                this.summaryData.total_broadcast_interval = response.data.broadcastSummary.broadcast_interval;
                if (this.selectedChannel !== '' && this.selectedBroadcast === '') {
                    this.summaryData.average_broadcast_interval = response.data.broadcastSummary.average_broadcast_interval;
                } else {
                    this.summaryData.average_broadcast_interval = '';
                }
            });
        },
        withFullUnitStringIfEnglish(value) {
            if (window.Laravel.lang === 'en') {
                let unit = '';
                const valueWithoutUnit = parseInt(value.replace(/[a-z]/gi, ''), 10);
                if (value.indexOf('m') > -1) {
                    unit = valueWithoutUnit > 1 ? 'Minutes' : 'Minute';
                } else if (value.indexOf('h') > -1) {
                    unit = valueWithoutUnit > 1 ? 'Hours' : 'Hour';
                } else if (value.indexOf('d') > -1) {
                    unit = valueWithoutUnit > 1 ? 'Days' : 'Day';
                }
                return `${valueWithoutUnit} ${unit}`;
            }
            return value;
        },
    },
    computed: {
        channelApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}`;
        },
        broadcastApi() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.selectedChannel}/broadcasts/${this.selectedBroadcast}`;
        },
        getExportUrl() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/export_channel`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
                if (this.selectedBroadcast !== '') {
                    apiLoc += `/${this.selectedBroadcast}`;
                }
            }
            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&interval=${this.requestInterval}`;

            return apiLoc;
        },
        storageUsageSummaryApi() {
            let apiLoc = `/cms/${this.selectedServiceAccount.key}/statistics/broadcast_summary`;
            if (this.selectedChannel !== '') {
                apiLoc += `/${this.selectedChannel}`;
            }

            apiLoc += `?started_at=${this.startDate}&ended_at=${this.endDate}&with_trashed=${this.includeTrashedChannel}&kind=${this.selectedType}`;

            return apiLoc;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        includeTrashedChannel(newValue) {
            this.selectize_channels.onSearchChange($('#select_channel').val());
        },
        selectedType(newValue) {
            this.selectize_channels.onSearchChange($('#select_channel').val());
            this.loadChart();
        },
        // transferInterval(newValue, oldValue) {
        //     if (newValue !== oldValue) {
        //         this.initTransferChartData();
        //         this.getTransferChartData();
        //     }
        // },
        // responseInterval(newValue, oldValue) {
        //     if (newValue !== oldValue) {
        //         this.initResponseChartData();
        //         this.getResponseChartData();
        //     }
        // },
        // requestInterval(newValue, oldValue) {
        //     if (newValue !== oldValue) {
        //         this.initRequestChartData();
        //         this.getRequestChartData();
        //     }
        // },
    },
};
</script>
